import React from 'react';
import { Routes, Route, Outlet } from "react-router-dom";
import { Box, Flex, Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import "./globals.css";
import Dash from "./dash/page";
import Scenario from './scenario/page';
import Header from './components/Header';
import Footer from './components/Footer';
import AuthCallback from './auth/AuthCallback';
import { DebugProvider } from './contexts/DebugContext';
import AuthGate from "./auth/AuthGate";

export default function App(): React.ReactElement {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<AuthGate />} />
        <Route path="scenario" element={<Scenario />} />
        <Route path="auth/callback" element={<AuthCallback />} />
      </Route>
    </Routes>
  );
}

function Layout(): React.ReactElement {
  return (
    <DebugProvider>
      <Theme>
        <Flex direction="column" justify="between" height="100vh">
          <Box>
            <Header />
            <Outlet />
          </Box>
          <Footer />
        </Flex>
      </Theme>
    </DebugProvider>
  );
}
